export default "/iconClose.svg";